import produce, { enableMapSet } from 'immer';
// The Product lists are stored as a Map so need to enable Map support for Immer
enableMapSet();
import { emptyProductLists, PRODUCT_LISTS_KEY, productListArrayToMap } from '.';
export function reducer(state, action) {
    switch (action.type) {
        case 'LOGIN':
            return produce(state, (draft) => {
                draft.loggedIn = true;
                const { list, listId } = action.payload;
                draft.lists.set(listId, list);
            });
        case 'LOGOUT': {
            return produce(state, (draft) => {
                draft.loggedIn = false;
                draft.lists = emptyProductLists();
            });
        }
        case 'UPDATE': {
            const { listId, articleNumber, variantArticleNumber, options, variantToReplace } = action.payload;
            return replaceItemInList(state, listId, articleNumber, {
                variantArticleNumber,
                variantToReplace,
                options
            });
        }
        case 'SET_LISTS': {
            return produce(state, (draft) => {
                draft.lists = action.payload.lists;
            });
        }
        // TODO
        //case 'UPDATE_LIST': {
        //  return produce(state, (draft) => {
        //    const { listId, update } = action.payload
        //    const list = draft.lists.get(listId)
        //    list.name = update.name
        //    //...
        //  })
        //}
        case 'ADD': {
            const { listId, variantArticleNumber, articleNumber, options } = action.payload;
            if (variantArticleNumber) {
                return addVariantToList(state, listId, articleNumber, {
                    variantArticleNumber,
                    options
                });
            }
            else {
                return addBaseProductToList(state, listId, articleNumber, options);
            }
        }
        case 'REMOVE': {
            const { listId, variantArticleNumber, articleNumber } = action.payload;
            const list = removeFromList(state, listId, articleNumber, {
                variantArticleNumber
            });
            return list;
        }
        case 'REPLACE': {
            return produce(state, (draft) => {
                const { list, listId } = action.payload;
                draft.lists.set(listId, list);
            });
        }
        case 'CLEAR_ITEMS': {
            return produce(state, (draft) => {
                const { listId } = action.payload;
                const list = draft.lists.get(listId);
                list.items = {};
            });
        }
        case 'CREATE_LIST': {
            return produce(state, (draft) => {
                const { list, listId } = action.payload;
                draft.lists.set(listId, list);
            });
        }
        case 'DELETE_LIST': {
            return produce(state, (draft) => {
                const { listId } = action.payload;
                draft.lists.delete(listId);
            });
        }
        default:
            throw new Error(`Unsupported action ${action} for product list reducer`);
    }
}
export function init(initialState) {
    if (typeof window === 'undefined')
        return initialState;
    /**
     * Migrate any legacy product list to the new format
     *
     * TODO Remove this code in next major release!
     */
    const LEGACY_LIST_KEY = 'productList';
    const legacyListData = JSON.parse(window.localStorage.getItem(LEGACY_LIST_KEY));
    if (legacyListData) {
        const defaultList = initialState.lists.get(null);
        Object.assign(defaultList.items, legacyListData);
        window.localStorage.removeItem(LEGACY_LIST_KEY);
        return {
            lists: initialState.lists,
            loggedIn: initialState.loggedIn,
            requestIdRef: initialState.requestIdRef
        };
    }
    const localStorageProductLists = JSON.parse(window.localStorage.getItem(PRODUCT_LISTS_KEY));
    const lists = (localStorageProductLists &&
        productListArrayToMap(localStorageProductLists)) ||
        initialState.lists;
    const updatedState = {
        lists,
        loggedIn: initialState.loggedIn,
        requestIdRef: initialState.requestIdRef
    };
    return updatedState;
}
export function addVariantToList(state, listId, articleNumber, { variantArticleNumber, options }) {
    // If the article number exists, update it
    // Otherwise create a new entry
    return produce(state, (draft) => {
        var _a, _b;
        const items = draft.lists.get(listId).items;
        items[articleNumber] = {
            options: ((_a = items[articleNumber]) === null || _a === void 0 ? void 0 : _a.options) || null,
            variants: produce(((_b = items[articleNumber]) === null || _b === void 0 ? void 0 : _b.variants) || {}, (draft) => {
                draft[variantArticleNumber] = {
                    options,
                    parentArticleNumber: articleNumber
                };
            })
        };
    });
}
export function addBaseProductToList(state, listId, articleNumber, options) {
    return produce(state, (draft) => {
        var _a;
        const items = draft.lists.get(listId).items;
        items[articleNumber] = {
            variants: ((_a = items[articleNumber]) === null || _a === void 0 ? void 0 : _a.variants) || null,
            options
        };
    });
}
export function removeFromList(state, listId, articleNumber, { variantArticleNumber }) {
    if (variantArticleNumber) {
        return produce(state, (draft) => {
            const items = draft.lists.get(listId).items;
            delete items[articleNumber].variants[variantArticleNumber];
            if (Object.keys(items[articleNumber].variants).length === 0 &&
                items[articleNumber].options === null) {
                delete items[articleNumber];
            }
        });
    }
    else {
        return produce(state, (draft) => {
            var _a;
            const items = draft.lists.get(listId).items;
            if ((_a = items[articleNumber]) === null || _a === void 0 ? void 0 : _a.variants) {
                items[articleNumber].options = null;
            }
            else {
                delete items[articleNumber];
            }
        });
    }
}
export function replaceItemInList(state, listId, articleNumber, { variantToReplace, variantArticleNumber, options }) {
    if (variantToReplace) {
        return produce(state, (draft) => {
            // Replacing is a delete + an add
            const items = draft.lists.get(listId).items;
            const variants = items[articleNumber].variants;
            delete variants[variantToReplace];
            items[articleNumber].variants = Object.assign(Object.assign({}, variants), { [variantArticleNumber]: {
                    options,
                    parentArticleNumber: articleNumber
                } });
        });
    }
    else {
        return produce(state, (draft) => {
            var _a;
            const items = draft.lists.get(listId).items;
            items[articleNumber] = {
                options: null,
                variants: Object.assign(Object.assign({}, (_a = items[articleNumber]) === null || _a === void 0 ? void 0 : _a.variants), { [variantArticleNumber]: {
                        options,
                        parentArticleNumber: articleNumber
                    } })
            };
        });
    }
}
//# sourceMappingURL=product-list-reducer.js.map